import React from "react";
import { useSelector } from "react-redux";

const AuthEight = () => {
  const locale = useSelector((state) => state.theme.locale);
  return (
    <div
      className="flex-1 flex flex-col items-center justify-center bg-no-repeat bg-cover text-center p-5"
      style={{ backgroundImage: `url('/img/auth/8.jpg')` }}
    >
      <img className="mb-10" alt="Carbon" src="/img/auth/icon5.png" />
      <p className="font-semibold text-[40px] text-white leading-snug max-w-[624px]">
        {locale === "en"
          ? "Mol-e provides comprehensive services tailored to your needs, such as emission calculation, reporting, and data management."
          : "Mol-e, emisyon hesaplama, raporlama ve veri yönetimi gibi ihtiyacınıza yönelik eksiksiz hizmetler sunar."}
      </p>
    </div>
  );
};

export default AuthEight;
